module.exports = __webpack_public_path__ + "img/beliefs.5325ea8.png";